import React from 'react';
import './InfoWindow.scss';
import Icon from '../../icons';
import { ORDER_STATUSES_DISPLAY, STEP_TYPE, DAYTIME_FORMAT } from '../../constants';
import moment from 'moment';
import i18n from '../../i18n';

export const VehicleInfoWindow = ({ item, imageBaseUrl }) => {
  const t = (key, options) => i18n.t(key, { ns: 'routes', ...options });

  const headerContent = (
    <div className="info-header">
      <Icon type="InfoWindowCar" className="info-icon" color={item.color} />
      <span className="info-id" style={{ color: item.color }}>
        {item?.driver?.name}
      </span>
    </div>
  );

  const startRouteImages = item.fileRoutes?.filter((img) => img.type === 'START_ROUTE').map((fr) => fr.file) || [];
  const endRouteImages = item.fileRoutes?.filter((img) => img.type === 'END_ROUTE').map((fr) => fr.file) || [];

  const infoWindow = (
    <div className="info-window">
      <div className="info-content">
        <div className="info-detail">
          <strong>{t('infoWindow.driver')}</strong> <span>{item?.driver?.name}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.phone')}</strong> <span>{item?.driver?.phone}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.startAddress')}</strong> <span>{item.startAddress}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.endAddress')}</strong> <span>{item.endAddress || '-'}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.hubName')}</strong> <span>{item.schedulerForm?.fleet?.hub?.name}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.hubAddress')}</strong> <span>{item.schedulerForm?.fleet?.hub?.startAddress}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.fleetName')}</strong> <span>{item.schedulerForm?.fleet?.name}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.weight')}</strong> <span>{item.schedulerForm?.fleet?.weight}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.volume')}</strong> <span>{item.schedulerForm?.fleet?.volume}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.shiftStart')}</strong> <span>{item.shiftStart}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.actualShiftStart')}</strong>
          <span>{item.actualShiftStart ? moment(item.actualShiftStart).format('H:mm') : ''}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.shiftEnd')}</strong> <span>{item.shiftEnd}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.dispatchedAt')}</strong>{' '}
          <span>{item.dispatchedAt ? moment(item.dispatchedAt).format(DAYTIME_FORMAT) : ''}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.actualShiftEnd')}</strong>
          <span>{item.actualShiftEnd ? moment(item.actualShiftEnd).format('H:mm') : ''}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.tag')}</strong> <span>{item.schedulerForm?.fleet?.tag}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.skills')}</strong> <span>{item.schedulerForm?.skills?.join(', ')}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.numberOfPickups')} </strong> <span>{item.countPickup}</span>
        </div>
      </div>

      {(startRouteImages.length > 0 || endRouteImages.length > 0) && (
        <div className="info-images">
          {startRouteImages.length > 0 && (
            <div className="image-section">
              <strong>{t('infoWindow.startRouteImages')}</strong>
              <div className="image-gallery">
                {startRouteImages.map((image) => (
                  <a
                    key={image.id}
                    href={`${imageBaseUrl}${image.key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="route-image-link"
                  >
                    <img src={`${imageBaseUrl}${image.key}`} alt="Start Route" className="route-image" />
                  </a>
                ))}
              </div>
            </div>
          )}

          {endRouteImages.length > 0 && (
            <div className="image-section">
              <strong>{t('infoWindow.endRouteImages')}</strong>
              <div className="image-gallery">
                {endRouteImages.map((image) => (
                  <a
                    key={image.id}
                    href={`${imageBaseUrl}${image.key}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="route-image-link"
                  >
                    <img src={`${imageBaseUrl}${image.key}`} alt="End Route" className="route-image" />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
  return { headerContent, infoWindow };
};

export const StopInfoWindow = ({ item, items }) => {
  const t = (key, options) => i18n.t(key, { ns: 'routes', ...options });

  const headerContent = (
    <div className="info-header">
      <Icon type="InfoWindowCar" className="info-icon" />
      <a
        className="info-id"
        style={{ color: item.color }}
        href={`${window.location.origin}/admin/orders/${item.orderCode}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {item.orderCode}
      </a>
    </div>
  );

  const steps =
    item.type === STEP_TYPE.delivery
      ? items.filter((i) => i.type === STEP_TYPE.pickup && i.orderIds?.includes(item.orderId))
      : items.filter((i) => i.type === STEP_TYPE.delivery && item.orderIds?.includes(i.orderId));

  const infoWindow = (
    <div className="info-window">
      <div className="info-content">
        <div className="info-detail">
          <strong>{t('infoWindow.location')}</strong> <span>{item?.address}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.duration')}</strong> <span>{item?.duration}</span>
        </div>
        <div className="info-detail">
          <strong>{item.type === STEP_TYPE.pickup ? t('infoWindow.pickupName') : t('infoWindow.deliveryName')}</strong>{' '}
          <span>{item?.name}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.arrivalTime')}</strong> <span>{item?.arrivalTime || '-'}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.finishTime')}</strong> <span>{item?.finishTime || '-'}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.startTime')}</strong> <span>{item?.startTime}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.endTime')}</strong> <span>{item?.endTime}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.type')}</strong> <span>{item?.type}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.status')}</strong>{' '}
          <span>{ORDER_STATUSES_DISPLAY[item?.orderStatus] || item?.orderStatus}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.orderTypes')}</strong> <span>{item?.orderTypes?.join(', ')}</span>
        </div>
        <div className="info-detail">
          <strong>{t('infoWindow.ticketNames')}</strong> <span>{item?.ticketNames?.join(', ')}</span>
        </div>
        {item?.unscheduledReason && (
          <div className="info-detail">
            <strong>{t('infoWindow.reason')}</strong>
            <span style={{ color: 'red' }}>{item?.unscheduledReason}</span>
          </div>
        )}
        <div className="info-detail">
          {item.type === STEP_TYPE.delivery && steps && (
            <>
              {' '}
              <strong>{t('infoWindow.pickup')}: </strong>
              <div className="steps">
                <div className="step" onClick={steps?.onClick}>
                  <div className="pickup" style={{ border: `2px solid ${item.color}`, color: item.color }}>
                    {steps?.index}
                  </div>
                  <b>{steps?.name}</b>
                </div>
              </div>
            </>
          )}
          {item.type === STEP_TYPE.pickup && (
            <>
              {' '}
              <strong>{t('infoWindow.deliveries')}: </strong>
              <div className="steps">
                {steps.map((step) => (
                  <div className="step" key={`${step.orderId}_${step.type}`} onClick={step?.onClick}>
                    <div className="delivery" style={{ border: `2px solid ${step.color}`, color: step.color }}>
                      {step?.index}
                    </div>
                    <b>{step.name}</b>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
  return { headerContent, infoWindow };
};

/**
 * Route-detail map pin → what the driver does at this point (Diego, Sep 2026).
 *
 * One panel per stop the pin stands for (a co-located pin covers several, e.g.
 * the depot a bike reloads at), each listing its orders with the status of THIS
 * leg, the box, the notes and where the parcel goes next / came from.
 *
 * Colours are literal on purpose: the panel floats over the Google basemap,
 * which is always light — see Marker.scss.
 */
export const StopsInfoWindow = ({ item }) => {
  const t = (key, options) => i18n.t(key, { ns: 'routes', ...options });
  const stops = item.stops || [];
  const label = (type) =>
    type === STEP_TYPE.pickup?.toUpperCase?.() || type === 'PICKUP'
      ? t('stopTypes.pickup', 'Pickup')
      : type === 'SERVICE'
        ? t('stopTypes.service', 'Service')
        : t('stopTypes.delivery', 'Delivery');

  const headerContent = (
    <div className="info-header">
      <span className="info-id">
        {stops.length > 1
          ? t('infoWindow.stopsHere', { count: stops.length, defaultValue: '{{count}} stops here' })
          : `${t('infoWindow.stop', 'Stop')} ${stops[0]?.stopNumber ?? ''}`}
        {item.isRouteStart ? ` · ${t('routeStart')}` : ''}
        {item.isRouteEnd ? ` · ${t('routeEnd')}` : ''}
      </span>
    </div>
  );

  const time = (planned, actual) => {
    if (!planned && !actual) return null;
    return (
      <span className="siw-time">
        {planned && (
          <span>
            {t('plannedLabel')} {planned}
          </span>
        )}
        {actual && (
          <span className="siw-actual">
            {t('actualLabel')} {actual}
          </span>
        )}
      </span>
    );
  };

  const infoWindow = (
    <div className="info-window stop-iw">
      {stops.map((stop) => (
        <div className="siw-stop" key={stop.id}>
          <div className="siw-head">
            <span className={'siw-chip ' + String(stop.type || '').toLowerCase()}>{label(stop.type)}</span>
            <span className="siw-num">#{stop.stopNumber}</span>
            <b className="siw-name">{stop.name}</b>
          </div>
          {stop.address && <div className="siw-addr">{stop.address}</div>}
          <div className="siw-meta">
            {time(stop.plannedArrival, stop.actualArrival)}
            {stop.timeWindow && (
              <span className="siw-window">
                {t('timeWindow')}: {stop.timeWindow}
              </span>
            )}
            {stop.phone && (
              <a className="siw-phone" href={`tel:${stop.phone}`}>
                {stop.phone}
              </a>
            )}
          </div>

          <div className="siw-orders">
            {stop.orders.map((o) => (
              <div className="siw-order" key={o.orderCode}>
                <div className="siw-order-head">
                  <a
                    href={`${window.location.origin}/admin/orders/${o.orderCode}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {o.orderCode}
                  </a>
                  {o.status && (
                    <span className={'siw-status ' + String(o.status).toLowerCase()}>
                      {ORDER_STATUSES_DISPLAY[o.status] || String(o.status).replace(/_/g, ' ').toLowerCase()}
                    </span>
                  )}
                  {o.partner && <span className="siw-tag">{o.partner}</span>}
                  {o.box && <span className="siw-tag box">{o.box}</span>}
                  {o.weight != null && <span className="siw-tag">{o.weight} kg</span>}
                </div>
                {o.otherLeg?.name && (
                  <div className="siw-leg">
                    {o.otherLeg.label === 'to' ? t('infoWindow.goesTo', '→ to') : t('infoWindow.comesFrom', '← from')}{' '}
                    <b>{o.otherLeg.name}</b>
                    {o.otherLeg.address ? ` · ${o.otherLeg.address}` : ''}
                  </div>
                )}
                {o.description && <div className="siw-note">{o.description}</div>}
                {o.note && <div className="siw-note">{o.note}</div>}
                {(o.driverNote || o.issueType) && (
                  <div className="siw-note driver">
                    {o.issueType ? `${String(o.issueType).replace(/_/g, ' ').toLowerCase()}` : ''}
                    {o.issueType && o.driverNote ? ' — ' : ''}
                    {o.driverNote || ''}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  return { headerContent, infoWindow };
};
